<br />
<br />
<button type='button' class='btn btn-primary' (click)='this.onSignOffButtonClicked()'>Sign off selected</button>
<br />
<br />

<app-grid
entity='job'
[filters]='this.filters'
[columns]='this.columns'
[buttons]='this.buttons'
[searchFilters]='this.searchFilters'
[searchFields]='this.searchFields'
[relationships]='["jobAssignment", "jobAssignment.driver", "jobAssignment.vehicle", "jobAssignment.subcontractor", "tippingPrice"]'
[backgroundSetter]='this.getRowColor'
[checkboxSelector]='true'
(checkboxSelected)='this.onCheckboxSelected($event)'
></app-grid>
